import React from "react";
import { Box, Typography, Fade } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import useDeliverableInsightsMessages from "../../hooks/useDeliverableInsightsMessages";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
    minHeight: "200px",
  },
  message: {
    fontSize: "14px",
    color: theme.palette.grey[600],
    fontStyle: "italic",
    lineHeight: 1.4,
    animation: "$fadeInOut 0.5s ease-in-out",
    textAlign: "center",
    marginTop: theme.spacing(2),
  },
  "@keyframes fadeInOut": {
    "0%": {
      opacity: 0,
      transform: "translateY(10px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
}));

/**
 * Componente que exibe mensagens rotativas durante o loading dos insights de deliverables
 * @param {boolean} isLoading - Se está carregando
 * @param {number} interval - Intervalo entre mensagens (opcional)
 * @param {React.Component} loadingComponent - Componente de loading (ex: ThreeDots)
 */
const DeliverableInsightsLoading = ({
  isLoading,
  interval,
  loadingComponent,
}) => {
  const classes = useStyles();
  const currentMessage = useDeliverableInsightsMessages(isLoading, interval);

  if (!isLoading) {
    return null;
  }

  return (
    <Box className={classes.container}>
      {loadingComponent}
      <Fade in={!!currentMessage} timeout={300}>
        <Typography className={classes.message} key={currentMessage}>
          {currentMessage}
        </Typography>
      </Fade>
    </Box>
  );
};

DeliverableInsightsLoading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  interval: PropTypes.number,
  loadingComponent: PropTypes.node,
};

DeliverableInsightsLoading.defaultProps = {
  interval: 2500,
  loadingComponent: null,
};

export default DeliverableInsightsLoading;
